import { Alert, Box, Modal, Snackbar, Typography } from '@mui/material';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import React, { useCallback, useContext, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { ThemeContext } from '../../../App';
import { lockIcon } from '../../../Constants';

const useStyles = makeStyles({
  mapLabel: {
    color: 'rgb(0 0 0 / 70%) !important',
    marginTop: '-50px',
    fontSize: '10px !important',
    background: 'white !important',
    boxShadow: '0 4px 8px rgb(0 0 0 / 20%)',
    padding: '4px',
    whiteSpace: 'pre',
    width: 'auto',
    fontFamily: '"Montserrat", sans-serif',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    borderRadius: '4px'
  },
  mapLabelFirstLine: {
    color: 'rgb(0 0 0 / 85%) !important',
    fontSize: '10px !important',
    fontFamily: '"Montserrat", sans-serif'
  }
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  minWidth: { xs: '70%', md: '40%' },
  maxWidth: { xs: '70%', md: '40%' },
  p: 2,
  borderRadius: 1
};

export default function DeviceMapModal({ openAssignedModal, handleClose, deviceDetail, city }) {
  const mapStyles = {
    height: '300px',
    width: '100%'
  };
  const classes = useStyles();
  const isLoaded = useContext(ThemeContext);
  const [center, setCenter] = useState({ lat: 28.499359150742354, lng: 77.06975633821554 });
  const [map, setMap] = useState(null);

  const options = {
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    scaleControl: false,
    keyboardShortcuts: false
  };

  const onMapLoad = useCallback((map) => setMap(map), []);

  return isLoaded ? (
    <Modal
      open={openAssignedModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid="device-map-modal"
    >
      <Box sx={style}>
        <Typography sx={{ fontSize: 18, fontWeight: 900, mb: 2 }}>Device Location</Typography>
        <GoogleMap
          mapContainerStyle={mapStyles}
          center={
            deviceDetail?.latestEvent !== null && deviceDetail?.latestEvent?.location_lat !== 0
              ? {
                  lat: deviceDetail?.latestEvent?.location_lat,
                  lng: deviceDetail?.latestEvent?.location_lng
                }
              : center
          }
          zoom={15}
          onLoad={onMapLoad}
          options={options}
        >
          <MarkerF
            position={{
              lat: deviceDetail.latestEvent?.location_lat,
              lng: deviceDetail.latestEvent?.location_lng
            }}
            icon={{
              url: lockIcon(
                deviceDetail?.deviceLiveStatus.toUpperCase() === 'ONLINE' ? '#027148' : '#8B0000'
              )
            }}
            label={{
              text: `${deviceDetail?.name}\n${city}`,
              className: classes.mapLabel
            }}
          />
        </GoogleMap>
      </Box>
    </Modal>
  ) : null;
}
